import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box, Tooltip, CircularProgress } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import { Field, ErrorMessage } from "formik"
import { PaginationDownSVG, PaginationUpSVG } from "../icons"
import { getFileRequestByPage } from "../../actions/documentModalActions"
import { documentsActions } from "../../actions/documentsActions"
import DownloadSVG from "../icons/DownloadSVG"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import { useHistory } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
	download: { flex: 0, display: "flex", alignItems: "center", padding: "4px 12px", borderRight: `solid 1px ${theme.palette.grey.D400}` },
	downloadOriginalFile: {
		padding: "10px",
		display: "flex",
		cursor: "pointer",
		justifyContent: "end",
		"&:hover": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))

const ViewerDownloadFile = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const { isNativeformatHeader } = props
	const [t] = useTranslation("global")
	const [pageNumber, setPageNumber] = useState(1)
	const { documentDetails } = useSelector((state) => state.documentModal)
	const singleFileDownloadStatus = useSelector((state) => state?.downloads?.documents)

	const [anchorEl, setAnchorEl] = useState(null)
	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<>
			<Box className={classes.download}>
				<Box
					className={classes.downloadOriginalFile}
					onClick={() => {
						dispatch(
							documentsActions.downloadSingleFileAction(
								documentDetails?.file_id,
								documentDetails?.name,
								documentDetails?.metadeta?.source
							)
						)
					}}
				>
					<Tooltip placement="top" title={t("downloadFile")}>
						<Box>
							{singleFileDownloadStatus[documentDetails?.file_id]?.downloading ? (
								<CircularProgress size={20} />
							) : (
								<DownloadSVG />
							)}
						</Box>
					</Tooltip>
				</Box>
				{!isNativeformatHeader && !["img", "audio", "video"].includes(documentDetails?.metadata?.source) && (
					<Box style={{ borderLeft: `solid 1px ${theme.palette.grey.D400}` }}>
						<IconButton style={{ color: theme.palette.text.primary, padding: "0 6px" }} onClick={handleClick}>
							<KeyboardArrowDownIcon />
						</IconButton>
						<Menu
							anchorEl={anchorEl}
							keepMounted
							open={open}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							getContentAnchorEl={null}
							onClose={handleClose}
						>
							<MenuItem
								onClick={() => {
									dispatch(
										documentsActions.downloadSingleFileAction(
											documentDetails?.file_id,
											documentDetails?.name,
											documentDetails?.metadeta?.source,
											true
										)
									)
									handleClose()
								}}
							>
								{t("downloadWithAnnotation")}
							</MenuItem>
						</Menu>
					</Box>
				)}
			</Box>
		</>
	)
}

export default ViewerDownloadFile
